<!--
 * @Author: lijiahui
 * @Date: 2020-02-18 13:47:44
 * @LastEditTime: 2021-05-10 14:25:48
 * @LastEditors: wenjing
 * @Description: In User Settings Edit
 * @FilePath: /xm-mini-program/Users/wj/checkout/feihe/xingmahui_front/src/components/activity/donation_active/activityResultApp.vue
 -->

<template>
	<div class="donationResult">
		<div class="formHeader">
			<!-- 返回 -->
			<span @click="goBack"></span>
			<!-- 飞鹤logo -->
			<div class="FHlogo"></div>
		</div>
		<div class="result_mask">
			<!-- 结果 老用户申请成功-->
			<div class="result_box" v-show="oldUserShow">
				<h2>申请成功</h2>
				<p>
					您已成功提交申请信息，请您在飞鹤星妈会微信公众号查看后续审核结果！
				</p>
				<div class="result_bg">
					<img
						src="../../../assets/images/activity/donationActive/olduserbg.png"
						alt=""
					/>
				</div>
			</div>
			<!-- 结果 新用户申请成功-->
			<div class="result_box" v-show="newUserShow">
				<h2>提交成功</h2>
				<p v-if="xhsApp">
					您已成功提交信息，请您关注“飞鹤星妈会”微信公众号-“母婴学院”菜单-“确认奶粉申领”，确认您的提交信息。确认后，我们会在1-5个工作日内进行审核。
				</p>
				<p v-if="!xhsApp">
					您已成功提交信息，请您关注“飞鹤星妈会”微信公众号，再次确认您的提交信息。确认后，我们会在1-5个工作日内进行审核。
				</p>
				<div class="qcode_box">
					<img :src="channelQcode" alt="" />
					<p v-if="!xhsApp">扫码关注查看审核结果</p>
				</div>
			</div>
			<!-- 回显页面 确认申请成功-->
			<div class="result_box" v-show="userSuccessShow">
				<h2>申请成功</h2>
				<p>
					您已成功提交申请信息，我们会在1-5个工作日内进行审核，请您关注“飞鹤星妈会”公众号查看您的申请结果
				</p>
				<div class="qcode_box">
					<img :src="channelQcode" alt="" />
					<p>扫码关注查看审核结果</p>
				</div>
			</div>
			<!-- 未提交过申请-->
			<div class="result_box" v-show="noCommitShow">
				<h2>您未提交过申请</h2>
				<p>您尚未提交过爱心奶粉申请，请去活动页面领取。</p>
				<div class="result_btn" @click="goReceive">去领取</div>
			</div>
		</div>
	</div>
</template>

<style lang="less" scoped>
	.donationResult {
		width: 100%;
		min-height: 100%;
		background: url(../../../assets/images/activity/donationActive/rmask2.png)
			no-repeat center bottom rgba(253, 234, 33, 1);
		background-size: 100% auto;
		.formHeader {
			width: 100%;
			height: 119px;
			background: url(../../../assets/images/activity/donationActive/headbg.png)
				no-repeat right bottom #feeb2d;
			background-size: 100% 100%;
			box-sizing: border-box;
			position: relative;
			span {
				width: 12px;
				height: 23px;
				background: url(../../../assets/images/activity/donationActive/form_arr_l.png)
					no-repeat left center;
				background-size: 100% 100%;
				display: block;
				margin-bottom: 25px;
				position: absolute;
				top: 13px;
				left: 20px;
			}
			.FHlogo {
				width: 124px;
				height: 25px;
				background: url(../../../assets/images/activity/donationActive/form_logos.png)
					no-repeat center center;
				background-size: 100% auto;
				position: absolute;
				top: 56px;
				left: 40px;
			}
		}
		.result_mask {
			background: url(../../../assets/images/activity/donationActive/rmask1.png)
				no-repeat left top;
			background-size: 100% auto;
			padding-bottom: 50px;
		}
		.result_box {
			height: 431px;
			background: rgba(255, 255, 255, 1);
			border-radius: 30px;
			margin: 0 20px;
			padding: 30px 22px 0;
			position: relative;
			h2 {
				font-size: 20px;
				font-weight: bold;
				color: rgba(5, 67, 152, 1);
				line-height: 30px;
				text-align: center;
			}
			p {
				margin-top: 20px;
				font-size: 14px;
				color: rgba(110, 53, 23, 1);
				line-height: 30px;
				font-weight: 400;
				a {
					color: rgba(5, 67, 152, 1);
					text-decoration: underline;
				}
				span {
					font-weight: bold;
				}
			}
			.again_btn {
				height: 51px;
				background: linear-gradient(
					-90deg,
					rgba(32, 61, 171, 1),
					rgba(39, 76, 213, 1)
				);
				border-radius: 10px;
				position: absolute;
				left: 24px;
				right: 24px;
				bottom: 52px;
				margin: auto;
				font-size: 20px;
				font-weight: bold;
				color: rgba(255, 255, 255, 1);
				line-height: 51px;
				text-align: center;
				a {
					display: block;
				}
			}
			.qcode_box {
				width: 100%;
				margin-top: 19px;
				text-align: center;
				img {
					width: 122px;
				}
				p {
					font-size: 14px;
					font-weight: 400;
					color: rgba(110, 53, 23, 1);
					line-height: 30px;
					margin: 0;
				}
			}
			.result_bg {
				height: 200px;
				width: 200px;
				margin: 0 auto;
				margin-top: 50px;
				img {
					height: 100%;
					width: 100%;
				}
			}
			.result_btn {
				background: linear-gradient(
					-90deg,
					rgba(32, 61, 171, 1),
					rgba(39, 76, 213, 1)
				);
				border-radius: 10px;
				width: 285px;
				height: 50px;
				margin-top: 220px;
				text-align: center;
				font-size: 20px;
				line-height: 50px;
				color: #fff;
				margin-left: 5px;
			}
		}
	}
</style>


<script>
	import store from '@/store'
	export default {
		name: "donationResult",
		props: {
			// resultCode:{
			//     type: String
			// },
			channelName: {
				type: String,
				default: ''
			},
			pageSource: {
				type: String,
				default: null
			},
			userShow: {
				type: Boolean,
			},
			successShow: {
				type: Boolean,
			},
			commitShow: {
				type: Boolean,
			}
		},
		data () {
			return {
				extStarMomHostName: this.$http.extStarMomHostName,
				oldUserShow: false,
				newUserShow: false,
				userSuccessShow: false,
				noCommitShow: false,
				// successShow:false,//申请成功
				// examineSuccessShow:false,//审核通过
				// examineFailShow:false,//审核未通过
				// examineShow:false,//审核中
				// sendShow:false,//发货通知
				channelQcode: require("../../../assets/images/activity/donationActive/qcode.jpg"),
				xhsApp: false
			};
		},
		watch: {
			successShow () {
				this.setUserCode();
			},
			userShow () {
				this.setUserState()
			},
			commitShow () {
				this.setCommitShow()
			}
		},
		mounted () {
			if (this.channelName && this.channelName != "") {
				if (this.pageSource == "xhs_app") {
					this.xhsApp = true;
					this.channelQcode = require("../../../assets/images/activity/donationActive/olduserbg.png");
				} else {
					this.channelQcode = "https://image-mom.feihe.com/channelQcode/" + this.pageSource + ".jpg"
				}
			}
		},
		methods: {
			setUserState () {
				this.oldUserShow = false
				this.newUserShow = false
				if (this.userShow == true) {
					this.newUserShow = true
				} else if (this.userShow == false) {
					this.oldUserShow = true
				}
			},
			setCommitShow () {
				if (this.commitShow == true) {
					this.noCommitShow = true
				}
			},
			setUserCode () {
				if (this.successShow == true) {
					this.userSuccessShow = true
				}
				// this.examineShow = false;
				// this.examineSuccessShow = false;
				// this.examineFailShow = false;
				// this.successShow = false;
				// this.sendShow = false;
				// /**
				//  * code值：
				//  * 200 可以填写用户信息
				//  * 201 已提交（审核中）
				//  * 202 审核通过
				//  * 203 审核驳回（审核未通过）
				//  * 204 订单创建了(发货通知)
				//  */
				// switch(this.resultCode){
				//     case "201":this.examineShow = true;
				//         break;
				//     case "202":this.examineSuccessShow = true;
				//         break;
				//     case "203":this.examineFailShow = true;
				//         break;
				//     case "true":this.successShow = true;
				//         break;
				//     case "204":this.sendShow = true;
				//         break;
				//     // default: this.successShow = true;
				// }
			},
			goReceive () {
				location.href = "/donationMilk";
			},
			goBack () {
				this.$emit("goBack");
			}
		},

	};
</script>
